<template>
    <div class="menu-container">
        <main-container>
            <div :class="`menu ${isMagSelected ? 'withSubMenu' : ''}`">
                <div class="menu-container-inner">
                    <menu-item :to="{ name: 'accueil' }">
                        {{ $privateDico.menu.dashboard.label }}
                    </menu-item>
                    <menu-item :to="{ name: 'cc' }">
                        {{ $privateDico.menu.cc.label }}
                    </menu-item>
                    <menu-item :to="{ name: 'conventions-panorama' }" v-if="isSubscribedToPanorama">
                        {{ $privateDico.menu.panorama.label }}
                    </menu-item>
                    <menu-item :to="{ name: 'mag' }">
                        {{ $privateDico.menu.mag.label }}
                    </menu-item>

                    <menu-item :to="{ name: 'contact' }">
                        {{ $privateDico.menu.contact.label }}
                    </menu-item>
                </div>
                <transition name="mag-sub-menu-transition">
                    <mag-sub-menu v-show="isMagSelected" />
                </transition>
            </div>
        </main-container>
    </div>
</template>
<script>
import Vue from "vue";
import MagSubMenu from "./MagSubMenu.vue";
import MenuItem from "./MenuItem.vue";
import userMixin from "src/mixins/user";

export default Vue.extend({
    components: {
        MenuItem,
        MagSubMenu,
    },
    props: ["user"],
    mixins: [userMixin],
    data() {
        return {
            isMagSelected: false,
        };
    },
    watch: {
        "$route.name": {
            handler: function (name) {
                this.isMagSelected = name === "mag";
            },
            deep: true,
            immediate: true,
        },
    },
});
</script>

<style lang="sass" scoped>
.mag-sub-menu-transition
    &-enter-active, &-leave, &-leave-to
        transition: opacity .15s ease-in
    &-enter, &-leave-to
        opacity: 0

.menu-container
    border-bottom: 1px solid $color-secondary
    +r(1024)
        border-bottom: none

.menu-container-inner
    display: flex
    width: 100%

.menu
    display: flex
    position: relative
    height: 50px
    transition: height .25s ease
    flex-direction: column
    align-items: center
    flex-grow: 1
    width: 100%
    &.withSubMenu
        height: 110px
    +r(1024)
        display: none

@media print
    .menu
        display: none
</style>
